export default {
  computed: {
    flexDriveSupported() {
      const isMotorbike = this.$store.state.newContract.insurance.vehicleRegistrationType === '03'
      const isCompany = this.$store.state.newContract.customerType === 'company'
      const whitelabelFlexdrive = this.$store.state.agent.whitelabel.flexDrive

      return !isMotorbike && !isCompany && whitelabelFlexdrive
    },
  },
}
